import { render, staticRenderFns } from "./parseJson.vue?vue&type=template&id=70b1d5ce&scoped=true&"
import script from "./parseJson.vue?vue&type=script&lang=js&"
export * from "./parseJson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b1d5ce",
  null
  
)

export default component.exports